<script>
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import singlePaneNoiseReduction50 from './images/single-pane-noise-reduction-50.png';
	import singlePaneNoiseReduction70 from './images/single-pane-noise-reduction-70.png';

	let {
		title = 'How Our Window Inserts Work',
		text = undefined,
		description,
		children,
	} = $props();
</script>

<Section>
	<h2>{title}</h2>
	<p>
		{#if description}
			{@render description?.()}
		{:else if text}
			{text}
		{:else}
			Indow window inserts use our patented Compression Tube to press inside
			your window frame and seal out noise. Our Standard Grade inserts block
			sound by 50% and our Acoustic Grade inserts block more than 70% when
			placed over operable single-pane windows. When placed over operable
			double-panes, Acoustic Grade inserts reduce noise by up to 12 dBA – that's
			more than a 50% reduction in noise and an STC rating of 42 to 45.
		{/if}
	</p>
	<Grid columns={2} rows={3} center>
		<Grid subgrid vertical>
			<h3 class="grid text-2xl font-bold text-indow-grey! uppercase">
				<span>ACOUSTIC</span>
				<span>INDOW INSERT</span>
				<span>+</span>
				<span>SINGLE-PANE</span>
			</h3>
			<Image
				src={singlePaneNoiseReduction70}
				alt="Diagram of Acoustic window inserts with single-pane windows. Reduce noise by 70%."
				class="max-w-52"
			/>
			<p
				class="
      flex max-w-[28ch] flex-row flex-wrap justify-center text-indow-grey!
      uppercase
    "
			>
				REDUCE NOISE UP TO 70% <span class="text-sm">(18.9 DBA REDUCTION)</span>
			</p>
		</Grid>
		<Grid subgrid vertical>
			<h3 class="grid text-2xl font-bold text-indow-grey! uppercase">
				<span>ACOUSTIC</span>
				<span>INDOW INSERT</span>
				<span>+</span>
				<span>DOUBLE-PANE</span>
			</h3>
			<Image
				src={singlePaneNoiseReduction50}
				alt="Diagram of Acoustic window inserts with double-pane windows. Reduce noise by up to 50%."
				class="max-w-52"
			/>
			<p
				class="
      flex max-w-[28ch] flex-row flex-wrap justify-center text-indow-grey!
      uppercase
    "
			>
				REDUCE NOISE UP TO 50% <span class="text-sm">(10.2 DBA REDUCTION)</span>
			</p>
		</Grid>
	</Grid>
	{@render children?.()}
</Section>
